import React, {useState} from 'react';
import UploadIcon from "../../Assets/upload.svg";

// modal
import Modal from "../Modal";

function Upload(props) {

    const [open, setOpen] = useState(false);

    const CloseModal = (e) => {
        setOpen(false)
    };

    return (
        <div>
            <img
                src={UploadIcon}
                onClick={() => setOpen(true)}
                alt='UploadIcon'
                className='ml-3 cursor-pointer'
            />
            {
                open && <Modal
                    Type='excel-upload'
                    Close={(e) => CloseModal(e)}
                    Upload={(e, fileinfo) => props.Upload(e, fileinfo)}
                />
            }
        </div>
    );
}

export default Upload;